<template>
  <div v-if="clientRequests && isUpdate">
    <user-requests
      :first_name="client.first_name"
      :last_name="client.last_name"
      :requests="clientRequests"
      @done="done"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import userRequests from '@/components/lists/users/userRequests'

export default {
    components: {
        userRequests,
    },
    props: {
        client: {
            required: true,
        },
        isUpdate: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            clientRequests: 'clientRequests',
        }),
    },
    methods: {
        ...mapActions({
            fetchClientRequests: 'fetchClientRequests',
        }),
        done() {
            this.fetchClientRequests(this.client.id)
        },
    },
    mounted() {
        this.fetchClientRequests(this.client.id)
    },
}
</script>
